var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cart)?_c('div',{staticClass:"row"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"col-4 mb-3"},[_c('box-item',{attrs:{"box":item,"cart":_vm.cart,"authenticated":_vm.authenticated}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }